import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {
  GetOrganizationToken,
  GetOrganizationTokenComplete,
  GetOrganizationTokenError,
  GetOrganizationTokens,
  GetOrganizationTokensComplete,
  GetOrganizationTokensError,
  OrganizationTokenActionTypes
} from '../actions/organization-token.actions';
import {catchError, exhaustMap, map} from 'rxjs/operators';
import {of, forkJoin, Observable} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {TokenService} from '../services/token.service';
import {GetOrganizationTokenRequest, GetOrganizationTokenResponse, GetOrganizationTokensRequest} from '../models/token';

@Injectable()
export class OrganizationTokenEffects {

  @Effect()
  getOrganizationToken$ = this.actions$.pipe(
    ofType(OrganizationTokenActionTypes.GetOrganizationToken),
    map((action: GetOrganizationToken) => action.payload),
    exhaustMap((getOrganizationTokenRequest: GetOrganizationTokenRequest) =>
      forkJoin(this.tokenService.getOrganizationToken(getOrganizationTokenRequest), of(getOrganizationTokenRequest.organizationId))
        .pipe(
          map(([getOrganizationTokenResponse, organizationId]: [GetOrganizationTokenResponse, string]) =>
            new GetOrganizationTokenComplete({
              id: organizationId,
              token: getOrganizationTokenResponse.token
            })
          ),
          catchError((error: HttpErrorResponse) => of(new GetOrganizationTokenError({
            errorMessage: error.message
          })))
        )
    )
  );

  @Effect()
  getOrganizationTokens$ = this.actions$.pipe(
    ofType(OrganizationTokenActionTypes.GetOrganizationTokens),
    map((action: GetOrganizationTokens) => action.payload),
    exhaustMap((getOrganizationTokensRequest: GetOrganizationTokensRequest) => {
        const tokenObs = getOrganizationTokensRequest.organizationIds.reduce(
          (acc: Observable<GetOrganizationTokenResponse>[], organizationId: string) => {
            return [
              ...acc,
              this.tokenService.getOrganizationToken({
                organizationId,
                accessToken: getOrganizationTokensRequest.accessToken
              })
            ];
          }, []
        );

        return forkJoin(forkJoin(tokenObs), of(getOrganizationTokensRequest.organizationIds))
          .pipe(
            map(([getOrganizationTokensResponse, organizationIds]: [GetOrganizationTokenResponse[], string[]]) => {
              const organizationTokenEntities = organizationIds.reduce((acc: { [id: string]: string }, id: string, index: number) => {
                return {
                  ...acc,
                  [id]: getOrganizationTokensResponse[index].token
                };
              }, {});
              return new GetOrganizationTokensComplete(organizationTokenEntities);
            }),
            catchError((error: HttpErrorResponse) => of(new GetOrganizationTokensError({
              errorMessage: error.message
            })))
          )
      }
    )
  );

  constructor(private actions$: Actions,
              private tokenService: TokenService) {
  }
}
